import { render, staticRenderFns } from "./rateUpdate.vue?vue&type=template&id=3831b166&scoped=true&"
import script from "./rateUpdate.vue?vue&type=script&lang=js&"
export * from "./rateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./rateUpdate.vue?vue&type=style&index=0&id=3831b166&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831b166",
  null
  
)

export default component.exports